"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Help = _interopRequireDefault(require("@material-ui/icons/Help"));
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    iconButton: {
      padding: 0
    },
    absolute: {
      position: 'absolute',
      top: theme.spacing(1),
      right: theme.spacing(1)
    }
  };
});
var Helper = function Helper(_ref) {
  var message = _ref.message,
    small = _ref.small,
    inline = _ref.inline;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: message
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    className: (0, _clsx["default"])(classes.iconButton, !inline && classes.absolute),
    size: small ? 'small' : 'medium',
    "aria-label": "help"
  }, /*#__PURE__*/_react["default"].createElement(_Help["default"], {
    fontSize: "inherit"
  })));
};
Helper.propTypes = {
  message: _propTypes["default"].string.isRequired,
  small: _propTypes["default"].bool,
  inline: _propTypes["default"].bool
};
Helper.defaultProps = {
  small: false,
  inline: false
};
var _default = exports["default"] = Helper;